import update from '../update';
import {
  STATE_LIST_LOADED,
  GEOFILTER_LIST_LOADED,
  RESPONSE_CONSTRAINT_LIST_LOADED
} from './constants';

const initialState = {
  states:[],
  geofilters:[],
  responseConstraints:[]
};

export default function(state=initialState,action){
  switch(action.type){

  case STATE_LIST_LOADED:
    return update(state,{
      states:{
        $set:action.payload
      }
    });

  case GEOFILTER_LIST_LOADED:
    return update(state,{
      geofilters:{
        $set:action.payload
      }
    })

  case RESPONSE_CONSTRAINT_LIST_LOADED:
    return update(state,{
      responseConstraints:{
        $merge:action.payload
      }
    });

  default:
    return update(state,{});
  }
}


// WEBPACK FOOTER //
// ./src/shared/redux/audience/reducer.js